import { useMPEFetch } from '@retail/app/hooks';
import { useMgPrisConfig } from '@retail/app/stores/app-config';
import { useAuthContext } from '@retail/auth/data-access';
import { mpeApi } from '@retail/mgpris/config';
import { CompetitorPricesDTO } from '@retail/my-assortment/types';
import { QueryOptions } from '@shared/fetch-utils';
import { buildUrl } from '@shared/utils';

interface Props extends QueryOptions {
  assortmentId: number;
  supplierNumber?: number;
  productGroupNumbers?: string[];
  discountGroupCodes?: string[];
  query?: string;
  withAgreementPrices?: boolean;
}

export function useFetchCompetitorPrices({
  assortmentId,
  supplierNumber,
  productGroupNumbers,
  discountGroupCodes,
  query,
  withAgreementPrices,
  ...queryOptions
}: Props) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMPEFetch<CompetitorPricesDTO>({
    method: 'GET',
    queryKey: [
      'assortment-competitor-prices',
      assortmentId,
      supplierNumber,
      productGroupNumbers,
      discountGroupCodes,
      withAgreementPrices,
      query,
    ],
    token,
    url: buildUrl({
      base: mpe.url,
      route: mpeApi.competitorPrices.assortment.assortmentId.getFullLinkPath({ assortmentId }),
      searchParams: {
        supplierNumber,
        productGroupNumbers,
        discountGroupCodes,
        query,
        withAgreementPrices,
      },
    }),
    ...queryOptions,
  });
}
